// src/pages/ContactPage.js

function ContactPage() {
  return (
    <section className="contact-section">
      <div className="container">
        <h2>Get in Touch</h2>
        <p>Ready to book your adventure? Have questions or need a custom tour? Contact us today – we're here to help you plan your perfect Cape Town experience!</p>
        <div className="contact-links">
            <a href="https://wa.me/27736730809" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i> Chat on WhatsApp
            </a>
            <a href="tel:+27736730809" className="btn btn-call">
                <i className="fas fa-phone"></i> Call Us Now
            </a>
        </div>
        <p style={{marginTop: '2rem'}}><strong>Email:</strong> info@ebambatours.co.za </p>
        <p><strong>Address:</strong> 207 Kings Road, Brooklyn, Cape Town</p>
      </div>
    </section>
  );
}

export default ContactPage;
